document.addEventListener("DOMContentLoaded", (event) => {
    const burger = document.querySelector('.__burger');
    if (burger){
        burger.addEventListener('click', function(){
            document.querySelector('.__header').classList.toggle('is-open');
        });
    }

});
